// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-row {
  background: var(--item-view-background-color);
  box-shadow: var(--item-view-box-shadow);
  margin-bottom: 8px;
  padding: 5px;
}
.item-row .item-image {
  margin: 5px 15px;
}
@media (max-width: 992px) {
  .item-row .item-image {
    width: 100px;
    height: 100px;
  }
}
@media (min-width: 991px) {
  .item-row .item-image {
    border: 2px solid white;
    width: 90%;
    height: 90%;
    margin: 0px;
  }
  .item-row .item-image.landscape {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  }
}
.item-row .item-text {
  padding: 0 10px;
}
@media (min-width: 991px) {
  .item-row .item-text {
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
@media (min-width: 991px) {
  .item-row {
    cursor: pointer;
    height: 100%;
    display: block;
  }
}

.item-name {
  font-size: var(--item-view-title-font-size);
  line-height: var(--item-view-title-line-height);
  text-transform: uppercase;
  color: black;
  font-family: AppFontBold, sans-serif;
}
.item-name ion-icon {
  width: 20px;
  height: 17px;
}
.item-name ion-icon.smaller {
  width: 28px;
  height: 20px;
}

.item-info {
  padding-top: 5px;
  font-size: var(--item-view-info-font-size);
  line-height: var(--item-view-info-line-height);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1A1A18;
}
.item-info.pfand {
  height: unset;
}

.price-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 10px 10px 5px 0px;
  justify-content: flex-start;
}
@media (max-width: 992px) {
  .price-col {
    justify-content: space-between;
  }
}
@media (min-width: 991px) {
  .price-col {
    padding: 0px 10px;
    align-items: flex-start;
  }
}
.price-col .action-icon {
  width: 22px;
  height: 22px;
}
@media (min-width: 991px) {
  .price-col .action-icon {
    display: none;
  }
}

.price {
  margin-bottom: 12px;
  color: var(--ion-color-black);
  font-family: AppFontBold, sans-serif;
}
@media (min-width: 991px) {
  .price {
    margin-bottom: 2px;
  }
}
@media (max-width: 992px) {
  .price {
    text-align: right;
  }
}

.img-block {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 991px) {
  .img-block {
    height: 120px;
    width: 100px;
  }
  .img-block ion-img {
    object-fit: contain;
    height: 100px;
  }
}

.small-screen {
  display: none;
}
@media (max-width: 992px) {
  .small-screen {
    display: flex;
  }
}

.big-screen {
  display: none;
  padding: 0px;
  margin: 0px;
}
@media (min-width: 991px) {
  .big-screen {
    display: block;
  }
  .big-screen .desktop_info_block {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    min-height: 160px;
    height: 100%;
  }
  .big-screen .desktop_info_block .left {
    width: 65%;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 5px 10px 10px;
  }
  .big-screen .desktop_info_block .left .item-name {
    font-size: 25px;
    line-height: 25px;
    margin: 0px;
  }
  .big-screen .desktop_info_block .left .item-info {
    -webkit-line-clamp: 2;
    font-size: 14px;
    line-height: 15px;
  }
  .big-screen .desktop_info_block .left .price {
    font-family: AppFonBold, sans-serif !important;
    font-weight: bold;
  }
  .big-screen .desktop_info_block .right {
    width: 35%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .big-screen .desktop_info_block .right ion-img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}

.cover-image {
  object-fit: cover;
  margin: 0px !important;
}

.bigger {
  zoom: 1.3;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: right;
  margin-top: 7px;
}
@media (max-width: 992px) {
  .measurment_text {
    text-align: left;
  }
}

.vat {
  color: black;
  font-size: 10px;
}

.measurement {
  font-family: AppFont;
  font-size: 11px;
  color: #1a1a18;
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,6CAAA;EAEA,uCAAA;EACA,kBAAA;EACA,YAAA;AAFF;AAIE;EACE,gBAAA;AAFJ;ACDE;EDEA;IAII,YAAA;IACA,aAAA;EADJ;AACF;ACbE;EDQA;IAQI,uBAAA;IACA,UAAA;IACA,WAAA;IACE,WAAA;EACN;EAAM;IACE,WAAA;IACA,YAAA;IACA,4BAAA;EAER;AACF;AAGE;EACE,eAAA;AADJ;AC7BE;ED6BA;IAKI,aAAA;IACA,aAAA;IACA,sBAAA;IACA,8BAAA;EADJ;AACF;ACrCE;EDCF;IAyCI,eAAA;IACA,YAAA;IACA,cAAA;EADF;AACF;;AAGA;EACE,2CAAA;EACA,+CAAA;EACA,yBAAA;EACA,YAAA;EACA,oCAAA;AAAF;AACE;EACE,WAAA;EACA,YAAA;AACJ;AAAI;EACE,WAAA;EACA,YAAA;AAEN;;AAGA;EACE,gBAAA;EACA,0CAAA;EACA,8CAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAAF;AAEE;EACE,aAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,0BAAA;EACA,2BAAA;AADF;AC9EE;ED0EF;IAOI,8BAAA;EACF;AACF;ACzFE;EDgFF;IAWI,iBAAA;IACA,uBAAA;EAEF;AACF;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;ACnGE;EDiGA;IAII,aAAA;EAEJ;AACF;;AACA;EACE,mBAAA;EACA,6BAAA;EACA,oCAAA;AAEF;AC9GE;EDyGF;IAKK,kBAAA;EAIH;AACF;AC7GE;EDmGF;IASI,iBAAA;EAKF;AACF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAMF;AC9HE;EDqHF;IAKI,aAAA;IACA,YAAA;EAQF;EAPE;IACE,mBAAA;IACA,aAAA;EASJ;AACF;;AADA;EACE,aAAA;AAIF;ACtIE;EDiIF;IAGI,aAAA;EAMF;AACF;;AAJA;EACE,aAAA;EACA,YAAA;EACA,WAAA;AAOF;ACvJE;ED6IF;IAKI,cAAA;EASF;EAPA;IACE,aAAA;IACA,uBAAA;IACA,8BAAA;IACA,iBAAA;IACA,YAAA;EASF;EARE;IACE,UAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,8BAAA;IACA,2BAAA;EAUJ;EATI;IACE,eAAA;IACA,iBAAA;IACA,WAAA;EAWN;EATI;IACE,qBAAA;IACA,eAAA;IACA,iBAAA;EAWN;EATI;IACE,8CAAA;IACA,iBAAA;EAWN;EARE;IACE,UAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAUJ;EATI;IACE,YAAA;IACA,WAAA;IACA,mBAAA;EAWN;AACF;;AANA;EACE,iBAAA;EACA,sBAAA;AASF;;AAPA;EACE,SAAA;AAUF;;AARA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAWD;AChNE;EDgMF;IAOE,gBAAA;EAaA;AACF;;AAXA;EACE,YAAA;EACA,eAAA;AAcF;;AAVA;EACE,oBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAaF","sourcesContent":["@import \"../../../theme/mixins\";\n\n.item-row {\n  background: var(--item-view-background-color);\n  // border: var(--item-view-border);\n  box-shadow: var(--item-view-box-shadow);\n  margin-bottom: 8px;\n  padding: 5px;\n\n  .item-image {\n    margin: 5px 15px;\n\n    @include mobile {\n      width: 100px;\n      height: 100px;\n    }\n    @include desktop {\n      border: 2px solid white;\n      width: 90%;\n      height: 90%;\n        margin: 0px;\n        &.landscape {\n          width: 100%;\n          height: 100%;\n          object-fit: cover !important;\n\n        }\n    }\n  }\n  \n  .item-text {\n    padding: 0 10px;\n  \n  \n    @include desktop {\n      padding: 10px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n    }\n  }\n\n  @include desktop {\n    cursor: pointer;\n    height: 100%;\n    display: block;\n  }\n}\n.item-name {\n  font-size: var(--item-view-title-font-size);\n  line-height: var(--item-view-title-line-height);\n  text-transform: uppercase;\n  color: black;\n  font-family: AppFontBold, sans-serif;\n  ion-icon {\n    width: 20px;\n    height: 17px;\n    &.smaller {\n      width: 28px;\n      height: 20px;\n    }\n  }\n}\n\n.item-info {\n  padding-top: 5px;\n  font-size: var(--item-view-info-font-size);\n  line-height: var(--item-view-info-line-height);\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical ;\n  overflow: hidden ;\n  text-overflow: ellipsis;\n  color: #1A1A18;\n\n  &.pfand {\n    height: unset;\n  }\n}\n\n.price-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 10px 10px 5px 0px;\n  justify-content: flex-start;\n  @include mobile {\n    justify-content: space-between;\n  }\n  // padding: 13px 10px 12px 0px;\n  @include desktop {\n    padding: 0px 10px;\n    align-items: flex-start;\n  }\n  \n\n\n  .action-icon {\n    width: 22px;\n    height: 22px;\n    @include desktop {\n      display: none;\n    }\n  }\n}\n.price {    \n  margin-bottom: 12px;\n  color: var(--ion-color-black);\n  font-family: AppFontBold ,sans-serif;\n   @include desktop {\n     margin-bottom: 2px;\n\n  }\n  @include mobile {\n    text-align: right;\n  }\n}\n.img-block{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  @include desktop {\n    height: 120px;\n    width: 100px;\n    ion-img {\n      object-fit: contain;\n      height: 100px;\n    }\n  }\n}\n\n\n\n\n\n.small-screen {\n  display: none;\n  @include mobile {\n    display: flex;\n  }\n}\n.big-screen {\n  display: none;\n  padding: 0px;\n  margin: 0px;\n  @include desktop {\n    display: block;\n  \n  .desktop_info_block {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    min-height: 160px;\n    height: 100%;\n    .left {\n      width: 65%;\n      display: flex;\n      height: 100%;\n      flex-direction: column;\n      justify-content: space-between;\n      padding: 10px 5px 10px 10px;\n      .item-name {\n        font-size: 25px;\n        line-height: 25px;\n        margin: 0px;\n      }\n      .item-info {\n        -webkit-line-clamp: 2;\n        font-size: 14px;\n        line-height: 15px;\n      }\n      .price {\n        font-family: AppFonBold, sans-serif !important;\n        font-weight: bold;\n      }\n    }\n    .right {\n      width: 35%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      ion-img {\n        height: 100%;\n        width: 100%;\n        object-fit: contain;\n      }\n    }\n    }\n  }\n}\n.cover-image {\n  object-fit: cover;\n  margin: 0px !important;\n}\n.bigger {\n  zoom: 1.3;\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: right;\n\tmargin-top: 7px;\n\t@include mobile {\n\t\ttext-align: left;\n\t}\n}\n.vat {\n  color: black;\n  font-size: 10px;\n  \n}\n\n.measurement {\n  font-family: AppFont;\n  font-size: 11px;\n  color: #1a1a18;\n  margin-bottom: 2px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
